import { track } from "~/modules/analytics/track";
import { NewAssetMonitorUserEvents } from "~/modules/analytics/events/new-asset-monitor";

// // // //

/**
 * trackFilterSearch
 * Tracks the event when a user types in the listing search input.
 */
export function trackFilterSearch(query: string) {
    track(NewAssetMonitorUserEvents.FilterSearch, {
        query,
        query_length: query.length,
    });
}

/**
 * trackFilterAssetClass
 * Tracks the event when a user changes the asset class filter.
 */
export function trackFilterAssetClass(selected: string[]) {
    track(NewAssetMonitorUserEvents.FilterAssetClass, {
        selected,
        count: selected.length,
    });
}

/**
 * trackFilterPlatform
 * Tracks the event when a user changes the platform filter.
 */
export function trackFilterPlatform(selected: string[]) {
    track(NewAssetMonitorUserEvents.FilterPlatform, {
        selected,
        count: selected.length,
    });
}

/**
 * trackFilterNetwork
 * Tracks the event when a user changes the network filter.
 */
export function trackFilterNetwork(selected: string[]) {
    track(NewAssetMonitorUserEvents.FilterNetwork, {
        selected,
        count: selected.length,
    });
}

/**
 * trackGroupingChange
 * Tracks the event when a user changes the table grouping (daily/weekly/monthly/etc.).
 */
export function trackGroupingChange(
    grouping: "daily" | "weekly" | "monthly" | "quarterly" | "yearly",
) {
    track(NewAssetMonitorUserEvents.GroupingChange, {
        grouping,
    });
}

/**
 * trackFilterClearAll
 * Tracks the event when a user clears all filters. The `source` distinguishes
 * the toolbar reset button from the empty-state CTA.
 */
export function trackFilterClearAll(props: {
    active_filter_count: number;
    source: "toolbar" | "empty_state";
}) {
    track(NewAssetMonitorUserEvents.FilterClearAll, props);
}

/**
 * trackIssuanceGroupToggle
 * Tracks the event when a user expands or collapses an issuance group row.
 */
export function trackIssuanceGroupToggle(props: {
    group_key: string;
    group_label: string;
    item_count: number;
    action: "expand" | "collapse";
}) {
    track(NewAssetMonitorUserEvents.IssuanceGroupToggle, props);
}
